var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeftMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.21 19.873l.708-.715a.437.437 0 000-.614l-5.54-5.605H19.57a.431.431 0 00.429-.433v-1.012a.431.431 0 00-.429-.433H7.377l5.54-5.606a.437.437 0 000-.613l-.706-.715a.425.425 0 00-.606 0l-7.48 7.566a.437.437 0 000 .614l7.48 7.566c.167.17.438.17.606 0z",
    fill: "#777"
  })));
}

export default SvgArrowLeftMobile;